import type { CSSProperties } from "react";
import { useColors } from "./ui";

const API_URL = import.meta.env.VITE_API_URL || "";

interface UserAvatarProps {
  userId?: string;
  picture?: string | null;
  name?: string | null;
  size?: number;
  style?: CSSProperties;
}

export function UserAvatar({
  userId,
  picture,
  name,
  size = 24,
  style,
}: UserAvatarProps) {
  const colors = useColors();
  const initial = (name || "?")[0].toUpperCase();

  const base: CSSProperties = {
    width: size,
    height: size,
    borderRadius: "50%",
    flexShrink: 0,
    ...style,
  };

  if (picture && userId) {
    return (
      <img
        src={`${API_URL}/avatars/${userId}`}
        alt=""
        style={{ ...base, objectFit: "cover" }}
      />
    );
  }

  return (
    <div
      style={{
        ...base,
        background: colors.textMuted,
        color: colors.bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size * 0.45,
        fontWeight: 600,
      }}
    >
      {initial}
    </div>
  );
}
